import { Box, Link } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ROUTING_CONFIG } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';


const useStyles = makeStyles()(theme => ({
  link: {
    marginTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    bottom: '10px',
    width: '100%',
    left: 0,
    '& a': {
      marginLeft: '20px',
    },
  },
}));


export const ResetPasswordFooter: React.FC = () => {
  const l10n = useL10n();
  const { classes } = useStyles();

  return (
    <Box className={classes.link}>
      <p style={{ margin: 0 }}>{l10n.auth.rememberYourPassword}</p>
      <Link component={RouterLink} to={ROUTING_CONFIG.login}>{l10n.navigation.signIn}</Link>
    </Box>
  );
};
